export function getLoadMoreLabel(loadingMore, canLoadMore) {
  if (loadingMore) {
    return "Caricamento...";
  }
  if (canLoadMore) {
    return "Carica altro";
  }
  return "Non ci sono altri messaggi";
}

export function resolveEditedAttachmentName({ file, attachmentRemoved, editingAttachmentName }) {
  if (file) {
    return file.name;
  }
  if (attachmentRemoved) {
    return null;
  }
  return editingAttachmentName;
}

export function resolvePendingAttachmentLabel({ file, hasExistingAttachment, editingAttachmentName }) {
  if (file?.name) {
    return file.name;
  }
  if (hasExistingAttachment) {
    return editingAttachmentName;
  }
  return null;
}

export function getApiErrorMessage(error, fallback) {
  return error?.response?.data?.message ?? error?.message ?? fallback;
}

export function downloadBase64File(base64, fileName) {
  const link = document.createElement("a");
  link.href = `data:application/octet-stream;base64,${base64}`;
  link.download = fileName || "allegato";
  link.click();
}
 